<div class="card-section" [ngClass]="{ 'flex-column': isSmallScreen(), 'flex-row': !isSmallScreen() }">

    <!-- Belt Analytics Card -->
    <mat-card *ngIf="isConveyor" class="belt-analytics-card">
        <div class="card-title">Belt Analytics</div>
        <div class="belt-data-row">
            <div class="belt-item">
                <div class="card-label">Up Time
                    <span>
                        <mat-icon [inline]="true"
                            matTooltip="Total time the conveyor belt is in motion (running)"
                            class="font-large">info</mat-icon>
                    </span>
                </div>
                <div class="card-value belt-up">{{beltAnalytics.upBelt.time}}
                    ({{beltAnalytics.upBelt.percentage.toFixed(2)}}%)</div>
            </div>
        
            <div class="belt-item">
                <div class="card-label">Off Time
                    <span>
                        <mat-icon [inline]="true"
                            matTooltip="Total time the conveyor belt is stationary (not running)"
                            class="font-large">info</mat-icon>
                    </span>
                </div>
                <div class="card-value belt-off-value">{{beltAnalytics.offBelt.time}}
                    ({{beltAnalytics.offBelt.percentage}}%)</div>
            </div>
        
            <div class="belt-item">
                <div class="card-label">Black Belt Time
                    <span class="flex">
                        <mat-icon [inline]="true"
                            matTooltip="Total Time Belt is running with no rocks"
                            class="font-large">info</mat-icon>
                    </span>
                </div>
                <div class="card-value black-belt-value">{{beltAnalytics.blackBelt.time}}
                    ({{beltAnalytics.blackBelt.percentage}}%)</div>
            </div>
        </div>
    </mat-card>

    <!-- Bench Data Card -->
    <mat-card class=" bench-data-card">
        <div class="card-title">Bench Data</div>
        <div class="belt-data-row">
            <div class="belt-item">
                <div class="card-label">Height</div>
                <div class="card-value">
                    <ng-container *ngIf="(benchHeight$ | async)?.length > 0; else noHeight">
                        <ng-container *ngFor="let val of (benchHeight$ | async); let last = last">
                            <measurement type="distance" [unitSystem]="(particleSizeUnitSystem$ | async)" [value]="val">
                            </measurement>
                            <span *ngIf="!last">, </span>
                        </ng-container>
                    </ng-container>
                    <ng-template #noHeight>---</ng-template>
                </div>
            </div>

            <div class="belt-item">
                <div class="card-label">Seam</div>
                <div class="card-value seam-value">
                    <ng-container *ngIf="(benchSeam$ | async)?.length > 0; else noSeam">
                        <ng-container *ngFor="let val of (benchSeam$ | async); let last = last">
                            <div class="card-value">{{val}}</div><span *ngIf="!last">, </span>
                        </ng-container>
                    </ng-container>
                    <ng-template #noSeam>---</ng-template>
                </div>
            </div>

            <div class="belt-item">
                <div class="card-label">Material</div>
                <div class="card-value">{{ (tag$.materialType | async) || '---' }}</div>
            </div>

            <div class="belt-item">
                <div class="card-label">Truck Count</div>
                <div class="card-value">
                    {{ (tag$.truckLoadCount | async) || '---' }}
                </div>
            </div>
        </div>
    </mat-card>